import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showAlert } from 'lib/functions/utils';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getAvailableTemplates = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/mailing/templates`,
    dispatch,
  });
  if (response) return response.data;
};

export const sendMail = (dispatch: Dispatch, warrantyId: number) =>
  useMutation({
    mutationKey: ['mailing', 'send', 'warranty', warrantyId],
    mutationFn: async (data: { recipients: string[] }): Promise<string> => {
      const response = await requestHandler({
        method: 'post',
        url: `internal/mailing/sgr-warranty/${warrantyId}`,
        dispatch,
        data,
      });
      if (response) return response.data;
      return 'OK';
    },
    onError: (error: AxiosError<{ displayMessage: string }>) => {
      const message = error.response?.data?.displayMessage;
      showAlert(dispatch, 'error', message ?? 'Error al enviar el correo');
    },
  });
